var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.5,
    height: 17.5,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fb",
    transform: "translate(-363 -136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    transform: "translate(363 136)",
    fill: "#569dfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22 23.5 L 8 23.5 C 3.864490032196045 23.5 0.5 20.1355094909668 0.5 16 L 0.5 8 C 0.5 3.864490032196045 3.864490032196045 0.5 8 0.5 L 22 0.5 C 26.1355094909668 0.5 29.5 3.864490032196045 29.5 8 L 29.5 16 C 29.5 20.1355094909668 26.1355094909668 23.5 22 23.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8 1 C 4.140190124511719 1 1 4.140190124511719 1 8 L 1 16 C 1 19.85980987548828 4.140190124511719 23 8 23 L 22 23 C 25.85980987548828 23 29 19.85980987548828 29 16 L 29 8 C 29 4.140190124511719 25.85980987548828 1 22 1 L 8 1 M 8 0 L 22 0 C 26.41827964782715 0 30 3.581720352172852 30 8 L 30 16 C 30 20.41827964782715 26.41827964782715 24 22 24 L 8 24 C 3.581720352172852 24 0 20.41827964782715 0 16 L 0 8 C 0 3.581720352172852 3.581720352172852 0 8 0 Z",
    stroke: "none",
    fill: "#5aa2fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_104498_facebook_icon",
    "data-name": "104498_facebook_icon",
    d: "M27.043,12.41H23.957V10.386a.824.824,0,0,1,.859-.937h2.178V6.108l-3-.012a3.8,3.8,0,0,0-4.087,4.087V12.41H17.982v3.443h1.925V25.6h4.05V15.853H26.69Z",
    transform: "translate(355.488 132.904)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.d1467070bceec690db0132cc5f4a5d14.svg";
export { ForwardRef as ReactComponent };